export default "__VITE_ASSET__x6v6YYC$__"